import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-alert-circle"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    _createElementVNode("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "12"
    }, null, -1),
    _createElementVNode("line", {
      x1: "12",
      y1: "16",
      x2: "12.01",
      y2: "16"
    }, null, -1)
  ]))]))
}
export default { render: render }